import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from '@insurancemenu/imenu-components-lib';
import { dateFormatters } from '@insurancemenu/imenu-components-lib/dist/helpers';
import { EnrollmentStage, Proposal } from 'types/enrollmentService';
import StageTag from 'components/common/enrollment/StageTag';
import { redirectToRoute } from 'routes/redirectToRoute';
import { RouteV2Id } from 'routes/routesConfigV2';
import { RATE_SEGMENT_TITLES } from 'global/utils/RateSegmentHelper';
import {
  CardStyled,
  CardHeaderStyled,
  DateColumnStyled,
  EffectiveDateLabelStyled,
  EffectiveDateValueStyled,
  FooterStyled,
  HeaderLeftStyled,
  ProposalKeyStyled,
  ProposalValueStyled,
} from './styles';

interface Props {
  groupId: string;
  periodId: string;
  effectiveDate: string;
  stage: EnrollmentStage;
  proposal: Proposal;
}

const ZywaveQuoteCard: React.FC<Props> = observer(({ groupId, periodId, effectiveDate, stage, proposal }) => {
  function onContinueClick(): void {
    redirectToRoute(RouteV2Id.QUOTE_CHECKLIST, {
      groupId,
      periodId,
      cartId: proposal.cartId,
    });
  }

  return (
    <CardStyled>
      <CardHeaderStyled>
        <HeaderLeftStyled>
          <DateColumnStyled>
            <EffectiveDateLabelStyled>Effective Date</EffectiveDateLabelStyled>
            <EffectiveDateValueStyled>
              {dateFormatters.normDateToShortAmericanDate(effectiveDate)}
            </EffectiveDateValueStyled>
          </DateColumnStyled>
          <StageTag stage={stage} />
        </HeaderLeftStyled>
        <Button color="primary" size="small" width="18.4rem" onClick={onContinueClick}>
          Continue
        </Button>
      </CardHeaderStyled>

      <FooterStyled>
        <ProposalKeyStyled>Type:</ProposalKeyStyled>
        <ProposalValueStyled>{RATE_SEGMENT_TITLES[proposal.rateSegment]}</ProposalValueStyled>
      </FooterStyled>
    </CardStyled>
  );
});

export default ZywaveQuoteCard;
